import { render } from "./attribute_xx_modify.vue?vue&type=template&id=2fdc8798&scoped=true"
import script from "./attribute_xx_modify.vue?vue&type=script&lang=js"
export * from "./attribute_xx_modify.vue?vue&type=script&lang=js"

import "./attribute_xx_modify.vue?vue&type=style&index=0&id=2fdc8798&scoped=true&lang=css"

import exportComponent from "/drone/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fdc8798"]])

export default __exports__